import request from '@/router/axios'
import env from '@/config/env'

// 获取办公用品分类列表
export const categoryList = (params) => {
  return request({
    url: env.officeUrl + '/officeItem/category',
    method: 'get',
    params
  })
}
// 获取物品分页
export const list = (params) => {
  return request({
    url: env.officeUrl + '/officeItem/page',
    method: 'post',
    data: params
  })
}
// 保存办公用品
export const save = (params) => {
  return request({
    url: env.officeUrl + '/officeItem/save',
    method: 'post',
    data: params
  })
}
// 保存办公用品
export const changeStatus = (params) => {
  return request({
    url: env.officeUrl + '/officeItem/changeStatus',
    method: 'put',
    params
  })
}
// 办公用品入库
export const incoming = (params) => {
  return request({
    url: env.officeUrl + '/officeItem/incoming',
    method: 'post',
    data: params
  })
}

// 办公用品出库
export const outgoing = (params) => {
  return request({
    url: env.officeUrl + '/officeItem/outgoing',
    method: 'post',
    data: params
  })
}
// 根据分类获取物品列表
export const listKind = (params) => {
  return request({
    url: env.officeUrl + '/officeItem/list/kind',
    method: 'get',
    params
  })
}
// 获取物品入库分页
export const incomingList = (params) => {
  return request({
    url: env.officeUrl + '/officeItem/incoming/page',
    method: 'get',
    params
  })
}
// 获取物品出库分页
export const outgoingList = (params) => {
  return request({
    url: env.officeUrl + '/officeItem/outgoing/page',
    method: 'get',
    params
  })
}
// 作废物品出入库记录
export const invalid = (params) => {
  return request({
    url: env.officeUrl + '/officeItem/record/invalid',
    method: 'put',
    params
  })
}
// 获取物品出库统计
export const statistics = (params) => {
  return request({
    url: env.officeUrl + '/officeItem/outgoing/statistics',
    method: 'get',
    params
  })
}
// 获取日志分页
export const logPage = (params) => {
  return request({
    url: env.officeUrl + '/log/page',
    method: 'post',
    data: params
  })
}
// 获取日志操作类型
export const logType = (params) => {
  return request({
    url: env.officeUrl + '/log/type',
    method: 'get',
    params
  })
}
// 查询操作人
export const sysUserList = (params) => {
  return request({
    url: env.ferryUrl + '/user/getSysUserList',
    method: 'get',
    params
  })
}
// 获取枚举
export const enumList = (params) => {
  return request({
    url: env.officeUrl + '/officeItem/enum',
    method: 'get',
    params
  })
}
// 导出物品
export const exportData = (params) => {
  return request({
    url: env.officeUrl + '/officeItem/export',
    method: 'post',
    data: params
  })
}
// 获取物品出入库记录分页
export const recordPage = (params) => {
  return request({
    url: env.officeUrl + '/officeItem/record/page',
    method: 'post',
    data: params
  })
}
